import { listDirAsync } from '../list-dir/index.js';
import { listGitTreeDirAsync } from '../../git/tree/index.js';
import type { GitBranchScope } from './resolve-git-branch-scope.js';
import type { FileBrowserListEntry } from './file-browser-result-types.js';

export async function executeFileBrowserList(params: {
  reqPath: string;
  sessionParentPath?: string;
  gitScope: GitBranchScope | null;
}): Promise<{ entries: FileBrowserListEntry[] } | { error: string }> {
  const { reqPath, sessionParentPath, gitScope } = params;
  return gitScope
    ? await listGitTreeDirAsync(gitScope.repoAbsPath, gitScope.branch, reqPath)
    : await listDirAsync(reqPath, sessionParentPath);
}
